module.exports = __webpack_public_path__ + "img/10.1a279b37.png";